
import {DataForm} from 'argo-js/src/view';
import {ChangePasswordModal} from '../components/ChangePasswordModal';
import {Toast} from '../ui/Toast';

export class Login extends DataForm {

  constructor(config) {
    super($.extend({
      errorMap: {
        TERMS_AND_CONDITIONS_MUST_BE_ACCEPTED: {
          message: 'error.TERMS_AND_CONDITIONS_MUST_BE_ACCEPTED'
        },
        MESSAGE_COULD_NOT_BE_SENT: {
          message: 'form.login.pinMessageNotSent'
        },
        ACCOUNTEXPIRED: {
          message: 'error.ACCOUNTEXPIRED'
        },
        BADCREDENTIALS: {
          message: 'error.BADCREDENTIALS'
        }
      },
      disableRedirect: false,
      validate: {
        validClass: false // disable valid input styling
      },
      events: {
        'keypress @pinInput': 'checkPinInput',
        'keyup @pinInput': 'submitPin'
      },
      ui: {
        loginFields: '.js-loginauth',
        pinContainer: '.js-pinauth',
        pinInput: '.js-pin',
      }
    }, config));
  }

  onInit() {
    let searchParams = new URLSearchParams(window.location.search);
    if(searchParams.has('logoff')) {
      if(this.app.user.isAuthorized()) {
        this.app.user
          .logout()
          .then(() => this.app.toHome());
      } else {
        this.app.toHome();
      }
    } else {
      super.onInit();
    }
  }

  onSubmit(data) {
    this.credentials = {
      username: data.email,
      password: data.password,
      rawPassword: data.password
    };

    if (data.pin) {
      this.credentials.password += data.pin;
    }

    return this.app.user.login(this.credentials.username, this.credentials.password);
  }

  onSuccess() {
    let cookieLang = getCookieValue('lang'); // eslint-disable-line no-undef
    if (cookieLang) {
      this.app.user
        .updateLocale(cookieLang)
        .then(() => {this.checkRedirect();});
    } else {
      document.cookie = `lang=${this.app.user.get('locale')}; expires="${(new Date((new Date).getTime() + 365 * 86400000)).toUTCString()}"; path=/`;
      this.checkRedirect();
    }
  }

  checkRedirect() {
    if (!this.config.disableRedirect) {
      let target = this.ui.form.data('target');
      target ? this.app.redirect(target) : this.app.toHome();
    }
  }

  onResendPin(e, $btn) {
    $btn.addClass('loading').prop('disabled', true);
    this.app.user
      .login(this.credentials.username, this.credentials.rawPassword)
      .finally(() => {
        $btn.removeClass('loading').prop('disabled', false);
      })
      .catch({errCode: 'MFAPINMISSING'}, () => {
        Toast.success(this.t('form.login.resendPin.success'));
        this.ui.pinInput.val('').focus();
        this.detachFormError();
      });
  }

  checkPinInput(e) {
    let value = $(e.currentTarget).val();
    if (!!value && value.toString().length >= 4) {
      e.preventDefault();
    }
  }

  submitPin(e) {
    let value = $(e.currentTarget).val();
    if (!!value && value.toString().length === 4 && e.keyCode >=48 && e.keyCode <= 57) {
      this.submitHandler();
    }
  }

  onBeforeError(resp) {

    if (resp.errCode === 'BADCREDENTIALS' && this.ui.pinContainer.is(':visible')) {
      this.setFormError(this.t('form.login.wrongPin'));
      return false;
    }
    if (resp.errCode === 'MFAPINMISSING') {
      this.ui.loginFields.hide();
      this.ui.pinContainer.show();
      this.ui.pinInput.val('').focus();
      return false;
    }
    if (resp.errCode === 'CREDENTIALSEXPIRED') {
      new ChangePasswordModal({
        app: this.app,
        credentials: {
          username: this.credentials.username,
          password: this.credentials.rawPassword,
        },
        message: this.t('error.CREDENTIALSEXPIRED'),
        preventClose: true,
        on: {
          'before:close': (dialog) => {

            this.credentials.rawPassword = dialog.config.credentials.password;
            this.setFormData({password: this.credentials.rawPassword});
            this.app.user
              .login(dialog.config.credentials.username, dialog.config.credentials.password)
              .then(this.handleSuccess.bind(this))
              .catch((resp) => {
                // send again a new code
                if (resp.errCode === 'MFAPINMISSING') {
                  Toast.success(this.t('form.login.resendPin.success'));
                }
                this.handleError(resp);
              });
          }
        }
      });

      // stop default error handling, clear value and reset validation
      this.setValue('password', '');
      this.validator.resetForm();
      return false;
    }
  }
}

